import React from 'react';
import { components } from '@glowforge/ui-common';
import PropTypes from 'prop-types';
import withCountryCode, { getValueFromCountryCode } from 'app/common/containers/country-code';

import './anouncement-banner.less';

const { Markdown } = components;

const AnnouncementBanner = ({
  pageMarkdown,
  countryCode,
}) => {
  const announcement = getValueFromCountryCode('homepage-announcement-express-shipping', countryCode, pageMarkdown);
  return (
    <div className='AnnouncementBanner fullWidth noMarginTop noMarginBottom'>
      <Markdown
        className='announcement'
        source={announcement} />
    </div>
  );
};

AnnouncementBanner.propTypes = {
  pageMarkdown: PropTypes.objectOf(PropTypes.string).isRequired,
  countryCode: PropTypes.string,
};

AnnouncementBanner.defaultProps = {
  countryCode: null,
};

export default withCountryCode(AnnouncementBanner);



// WEBPACK FOOTER //
// ./app/store/components/glowforge/anouncement-banner.jsx